import styled from "styled-components"


export const TableCustomStyled = styled.div` 
    td.ant-table-cell.ant-table-cell-with-append {
        text-align: center;
    } 
    margin-bottom: ${({ noMrb }) => (noMrb ? "0px" : "20px")};

    .ant-table-thead th.ant-table-column-sort {
        background: #01638D !important; /* Ghi đè màu nền */
    }
    
    .ant-table-thead th.ant-table-column-has-sorters:hover {
        background: ${props => (props.isPrimary ? "#01638D" : "#E4EFFE")};
    } 
    .ant-table-column-sorter-inner { 
        svg path {
            fill: rgba(243, 246, 249, 0.5);
        } 
        .active { 
            svg path {
                fill: #fff;
            } 
        } 
    }
    .ant-table-wrapper,
    .ant-table,
    .ant-table-container {
        &::-webkit-scrollbar,
        &::-webkit-scrollbar-track,
        &::-webkit-scrollbar-thumb {
            background-color: transparent !important;
        }
    } 
    .ant-table-sticky-scroll {
        display: none;
    } 
    .ant-spin-nested-loading {} 
    .ant-table-thead { 
        .ant-table-cell {
            background: ${props => (props.isPrimary ? "rgb(0, 145, 199)" : "#E4EFFE")};
            color: ${props => (props.isPrimary ? "#fff" : "#212529")};
            font-size: 13px;
        } 
    } 
    .ant-table-tbody > tr {} 
    .ant-table.ant-table-bordered 
    > .ant-table-container
    > .ant-table-header
    > table
    > thead
    > tr
    > th {
    /* border-right: ${props =>
    props.isPrimary ? "1px solid #f0f0f0" : "1px solid #f0f0f0"}; */
    /* border-right: unset; */
    } 
    .ant-table-container table > thead > tr:first-child th:first-child {
        border-top-left-radius: 4px;
    } 
    .ant-table-container table > thead > tr:first-child th:nth-last-child(2) { 
        /* border-top-right-radius: 4px; */ 
        /* border-right: 0px solid #f0f0f0 !important; */
    } 
    .ant-table-container table > thead > tr:first-child th:last-child {
        border-top-right-radius: 4px;
    } 
    .ant-table-thead > tr > th {
        text-align: center;
        padding: 4px 8px;
    }
    
    .ant-table-body {
        overflow: auto auto !important;
        transition: all linear 0.2s; 
        &::-webkit-scrollbar {
            width: 5px;
            height: 5px;
        }
        
        &::-webkit-scrollbar-thumb {
            background-color: #c5ced9;
            border-radius: 12px;
        } 
    } 
    .ant-table-body { 
        &::-webkit-scrollbar {
            background-color: #fff !important;
        }
        
        &::-webkit-scrollbar-track {
            background-color: #fff !important;
        }
        
        &::-webkit-scrollbar-thumb {
            background-color: #fff !important;
        } 
    }
    
    .ant-table-body:hover { 
        &::-webkit-scrollbar {
            background-color: #fff !important;
        }
        
        &::-webkit-scrollbar-track {
            background: #f1f1f1 !important;
        }
        
        &::-webkit-scrollbar-thumb {
            background: #ddd !important;
        } 
    }
    
    .ant-table-cell-scrollbar:not([rowspan]) {
        box-shadow: none;
    } 
    td.ant-table-cell {
        padding: 8px !important;
    } 
    .ant-table-placeholder { 
        .ant-table-cell {
            border-bottom: none !important;
        } 
    } 
    .ant-table-row {
        cursor: pointer;
    } 
    .ant-table-row-level-0:hover { 
        .float-action__wrapper {
            display: inline-flex;
        }
    } 
    .ant-table-tbody > tr:hover { 
        .float-action__wrapper {
            min-width: 80px;
            display: inline-flex;
        } 
    } 
    .ant-table-pagination {
        display: none
    }
`